<div class="product-gallery product-gallery-masonry" *ngIf="product">
    <div class="row m-0">
        <figure class="product-main-image" index="0">
            <span class="product-label label-new" *ngIf="product.new">New</span>
            <span class="product-label label-sale" *ngIf="product.sale_price">Sale</span>
            <span class="product-label label-top" *ngIf="product.top">Top</span>
            <span class="product-label label-out" *ngIf="(!product.stock || product.stock < 1) && product.variants.length < 1">Out Of Stock</span>

            <molla-image class="d-block position-relative"
                [src]="SERVER_URL + product.pictures[currentIndex].url"></molla-image>

            <button id="btn-product-gallery" href="javascript:;" class="btn-product-gallery" (click)="openLightBox()">
                <i class="icon-arrows"></i>
            </button>
        </figure>

        <div id="product-zoom-gallery" class="product-image-gallery mr-0 ml-0 width-style">
            <div class="row" >
                <div class="col-5 d-flex mb-1">
                    <button [class]="'product-masonry-item p-0 w-100' + ( 0 === currentIndex ? ' active' : '' )"
                        (click)="changeImage( $event, 0 )">
                        <molla-image [src]="SERVER_URL + product.sm_pictures[0].url" alt="Product back" class="w-100">
                        </molla-image>
                    </button>
                </div>

                <div class="col-7 d-flex mb-1" *ngIf="product.sm_pictures.length > 1">
                    <button [class]="'product-masonry-item p-0 w-100' + ( 1 === currentIndex ? ' active' : '' )"
                        (click)="changeImage( $event, 1 )">
                        <molla-image [src]="SERVER_URL + product.sm_pictures[1].url" alt="Product back" class="w-100">
                        </molla-image>
                    </button>
                </div>

                <div class="col-7 d-flex mb-1" *ngIf="product.sm_pictures.length > 2">
                    <button [class]="'product-masonry-item p-0 w-100' + ( 2 === currentIndex ? ' active' : '' )"
                        (click)="changeImage( $event, 2 )">
                        <molla-image [src]="SERVER_URL + product.sm_pictures[2].url" alt="Product back" class="w-100">
                        </molla-image>
                    </button>
                </div>

                <div class="col-5 d-flex mb-1" *ngIf="product.sm_pictures.length > 3">
                    <button [class]="'product-masonry-item p-0 w-100' + ( 3 === currentIndex ? ' active' : '' )"
                        (click)="changeImage( $event, 3 )">
                        <molla-image [src]="SERVER_URL + product.sm_pictures[3].url" alt="Product back" class="w-100">
                        </molla-image>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>